
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34978',
  depVersions: {
  "documents-public-ui": "static-1.34978",
  "atom": "static-1.5252",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2675",
  "client-types": "static-1.489",
  "cssUtils": "static-1.843",
  "customer-data-filters-ui": "static-1.40461",
  "customer-data-objects": "static-1.7856",
  "customer-data-property-utils": "static-1.8272",
  "documents-lib": "static-1.34983",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.352",
  "FormsCommonComponents": "static-1.86319",
  "FormUrlGenerator": "static-2.4898",
  "foundations-theming-specialty": "static-1.2331",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.107",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5770",
  "hs-test-utils": "static-1.8199",
  "hub-http": "static-1.6396",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11958",
  "HubStyleTokens": "static-2.11651",
  "I18n": "static-7.1645",
  "icons": "static-2.665",
  "jasmine-immutable": "static-1.3199",
  "jasmine-runner": "static-1.6632",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7328",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5570",
  "quartz": "static-1.7263",
  "react": "static-7.189",
  "react-dlb": "static-1.83",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16878",
  "react-select-plus": "static-1.108",
  "react-utils": "static-2.5468",
  "react-virtualized": "static-2.102",
  "reference-resolvers": "static-1.8352",
  "reference-resolvers-lite": "static-1.8273",
  "reporting-data": "static-1.68252",
  "reporting-reports": "static-1.67930",
  "reporting-snowflake": "static-1.56870",
  "reporting-testing-lib": "static-1.10185",
  "reporting-visualizations": "static-1.60328",
  "reselect": "static-3.8",
  "sales-content-partitioning": "static-1.9126",
  "sanitize": "static-1.4654",
  "sanitize-text": "static-1.8322",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1921",
  "signup-constants": "static-1.19320",
  "signup-ui-url-generator": "static-2.8235",
  "StyleGuideUI": "static-3.491",
  "superstore": "static-1.4934",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4934",
  "ui-addon-form-validation": "static-1.11166",
  "ui-asset-management-lib": "static-1.11258",
  "ui-images": "static-2.1206",
  "UIComponents": "static-3.8597",
  "usage-tracker": "static-1.7527",
  "usage-tracker-container": "static-1.7517",
  "usage-tracker-core": "static-1.7377",
  "viral-links-lib": "static-1.7248",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9835",
  "foundations-components": "static-1.8278",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1041",
  "quartz-core": "static-1.6482",
  "quick-fetch": "static-1.4044",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4834",
  "ui-addon-i18n": "static-1.11325",
  "ui-addon-upgrades": "static-9.18224",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3527",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3540",
  "quartz-webpack": "static-1.3487",
  "foundations-assets": "static-1.5051",
  "foundations-theming": "static-1.4615",
  "hub-http-shared-msw-handlers": "static-1.10401",
  "hubspotter-http": "static-1.4778",
  "sassPrefix": "static-1.160",
  "conversations-skeleton-state": "static-1.7425",
  "crm-message-bus": "static-1.43491",
  "customer-data-filters-ui-msw-helpers": "static-1.22896",
  "customer-data-objects-ui-components": "static-1.13206",
  "customer-data-reference-ui-components": "static-1.13353",
  "customer-data-ui-utilities": "static-1.10001",
  "events-data-lib": "static-1.414",
  "framework-builder-read-service-client": "static-1.4133",
  "framework-data-schema-quick-fetch": "static-1.6976",
  "framework-data-schema-resolvers": "static-1.7071",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3715",
  "inbound-db-properties-service-client": "static-1.3973",
  "multi-account-reference-resolvers": "static-1.1160",
  "onboarding-tours": "static-1.16937",
  "reporting-datasets-permissions-lib": "static-1.14194",
  "stylex": "static-1.37",
  "trellis-assets": "static-1.2284",
  "trellis-components": "static-1.2303",
  "trellis-theming": "static-1.1125",
  "ui-addon-teams": "static-1.21771",
  "quartz-auth": "static-1.938",
  "ui-business-units-lib": "static-1.9257",
  "usage-tracker-session-replay": "static-1.5213",
  "ai-components-ui-library": "static-1.9408",
  "ContentUtils": "static-1.68892",
  "customer-data-properties": "static-1.52183",
  "forms-ai-lib": "static-1.4592",
  "forms-utils-lib": "static-1.12907",
  "foundations-components-test-utils": "static-1.5761",
  "react-dnd-compat": "static-1.4791",
  "react-tinymce": "static-1.55720",
  "tinymce-config": "static-2.54846",
  "ui-gdpr-components": "static-1.10526",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3600",
  "HeadJS": "static-2.777",
  "framer-motion": "static-1.75",
  "hs-test-utils-bend-plugin": "static-1.3310",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "hs-locale-management": "static-1.208",
  "ui-fonts": "static-1.913",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4500",
  "csstype": "static-1.50",
  "quartz-head": "static-1.928",
  "web-vitals": "static-1.9",
  "batch-promise": "static-1.1721",
  "external-options-client-types": "static-1.4253",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.938",
  "frontend-preferences-client": "static-1.8104",
  "graphql": "static-1.85",
  "persist-promise": "static-1.3878",
  "reporting-client-types": "static-1.2604",
  "apollo-stack-hubspot": "static-3.89",
  "growth-payments-core": "static-1.25915",
  "hubspot-apollo-client": "static-1.5053",
  "foundations-components-legacy": "static-1.1303",
  "quartz-routing": "static-1.693",
  "hs-story-utils": "static-1.9602",
  "react-flip-move": "static-1.74",
  "nested-table": "static-1.413",
  "timezone-utils": "static-2.5420",
  "seat-types-lib": "static-1.408",
  "react-create-root-preference": "static-1.45",
  "bend-plugin-foundations-components": "static-1.4547",
  "floating-ui": "static-1.60",
  "react-aria": "static-1.69",
  "tanstack-table": "static-1.58",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.852",
  "mobile-manifest-mixins": "static-1.551",
  "module-federation": "static-1.29",
  "quartz-test": "static-1.938",
  "quartz-tracking": "static-1.642",
  "bend-plugin-chirp-manifest": "static-1.244",
  "chirp-fetch": "static-1.2064",
  "merchandise-lib": "static-1.267",
  "purchase-motions-components": "static-1.6175",
  "salesImages": "static-1.529",
  "ts-schema": "static-1.4207",
  "bender-build-tools": "static-1.3308",
  "bend-plugin-foundations-theming": "static-1.3098",
  "restore-request-side-panel-lib": "static-1.1367",
  "react-immutable-render-mixin": "static-1.9",
  "hs-resources": "static-1.355",
  "pulse": "static-1.791",
  "conditional-properties-service-client": "static-1.3924",
  "crm-pipelines-api-client-types": "static-1.4265",
  "fdsr-migration-layer": "static-1.190",
  "multi-currency-client-types": "static-1.3819",
  "getting-started-shared-tasks": "static-1.18940",
  "growth-data-modal": "static-1.5719",
  "growth-onboarding-confetti": "static-1.3239",
  "growth-onboarding-next-action-utils": "static-1.2442",
  "navigation-components": "static-1.18506",
  "onboarding-tours-client": "static-1.5151",
  "onboarding-tours-utils": "static-1.1003",
  "ui-shepherd-react": "static-3.10438",
  "ui-shepherd-tracker": "static-1.7819",
  "ui-universal-auth": "static-1.9186",
  "user-context": "static-1.5287",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "tanstack-virtual": "static-1.33",
  "hubspotter-http-shared-msw-handlers": "static-1.10399",
  "magpie-lib": "static-1.5670",
  "navigation-messaging": "static-1.7833",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.22211",
  "copilot-toolkit": "static-1.11592",
  "cms-field-types": "static-1.4991",
  "content-icons-ui": "static-1.2279",
  "integrations-lib": "static-1.16724",
  "calling-global-api": "static-1.65116",
  "calling-internal-common": "static-1.31489",
  "calling-lifecycle-internal": "static-1.66498",
  "calling-lifecycle-messages": "static-1.58792",
  "commerce-products-lib": "static-1.10227",
  "crm-links": "static-1.6491",
  "customer-data-properties-shared-msw-handlers": "static-1.9728",
  "file-manager-components": "static-1.24144",
  "formula-editor": "static-1.14570",
  "google-libphonenumber": "static-1.41",
  "inbounddb-objects-service-types": "static-1.4344",
  "meetings-icalendar-utils-lib": "static-1.809",
  "object-builder-ui-client": "static-1.49326",
  "pipeline-validation-client-types": "static-1.4094",
  "property-value-citations": "static-1.2797",
  "smart-property-lib": "static-1.8059",
  "tiered-pricing": "static-1.1722",
  "topics-actions-lib": "static-1.326",
  "ui-addon-iframeable": "static-1.9252",
  "zustand": "static-1.74",
  "final-form": "static-1.73",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.20138",
  "tinymce-themes": "static-1.56816",
  "data-token-picker": "static-1.16720",
  "hub-http-contrib": "static-1.3219",
  "interframe": "static-3.4932",
  "tinymce-data": "static-1.40931",
  "tinymce-plugins": "static-1.57960",
  "ui-addon-sales-email": "static-1.5389",
  "onboarding-scopes": "static-1.6635",
  "ui-addon-opt": "static-4.8537",
  "apollo-link-hub-http": "static-2.4828",
  "hubspot-apollo-cache": "static-1.512",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.349",
  "purchase-motions-api": "static-1.6178",
  "event-emitter": "static-1.1127",
  "bend-plugin-pulse": "static-1.294",
  "fast-json-patch": "static-1.66",
  "onboarding-data-sync-lib": "static-1.2266",
  "growth-onboarding-next-action-components": "static-1.2470",
  "user-context-client": "static-1.4727",
  "idb-keyval": "static-1.47",
  "magpie-types": "static-1.5130",
  "nest": "static-1.412",
  "reactive-lib": "static-1.901",
  "simple-logging-lib": "static-1.3226",
  "unified-auth-core-lib": "static-1.982",
  "getting-started-shared-tasks-store": "static-1.18058",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1357",
  "integrations-error-boundary-lib": "static-1.14139",
  "integrations-tracking-lib": "static-1.5784",
  "native-integrations-shared-strings": "static-1.7957",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10541",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.700",
  "calling-error-reporting": "static-1.31496",
  "shared-worker-versioning": "static-1.11213",
  "calling-usage-tracker": "static-1.6717",
  "voice-sms-access-library": "static-1.1635",
  "customer-data-tracking": "static-1.7062",
  "commerce-permissions": "static-1.952",
  "products-iframe-lib": "static-1.8362",
  "products-ui-components-shared-msw-handlers": "static-1.10783",
  "location-customization-utils-lib": "static-1.9783",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4325",
  "video-components-external": "static-1.11864",
  "video-data-lib": "static-1.35522",
  "bark-lib": "static-1.16663",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.98",
  "crm-properties-common-lib": "static-1.6064",
  "react-codemirror": "static-1.10810",
  "data-agent-kit": "static-1.474",
  "feedback-loader": "static-1.29627",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10484",
  "fsm": "static-1.3906",
  "policy-lib": "static-1.6961",
  "react-colorpicker": "static-2.10384",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10547",
  "FileManagerLib": "static-1.39784",
  "NamespacedHubStyle": "static-2.9178",
  "FileManagerCore": "static-1.39643",
  "content-assistance-lib": "static-1.8025",
  "layout-dnd-components": "static-1.12786",
  "layout-dnd-utils": "static-1.11761",
  "ui-addon-emoji-picker": "static-1.10060",
  "ui-brand-identity-lib": "static-1.15936",
  "InboxConnectUtils": "static-4.15296",
  "meetings-connect-utils-lib": "static-1.7783",
  "breeze-engine-core": "static-1.635",
  "ably": "static-2.2",
  "highlight.js": "static-1.82",
  "universal-page-editor-lib": "static-1.3189",
  "adobe-sign-auth-lib": "static-1.203",
  "ads-unified-auth-lib": "static-1.695",
  "google-sheets-integration-lib": "static-1.768",
  "microsoft-drive-integration-lib": "static-1.878",
  "surveymonkey-integration-lib": "static-1.219",
  "slack-ui-library": "static-1.10574",
  "calling-orchestration-schema": "static-1.36412",
  "sales-views-client-types": "static-1.4435",
  "crm-record-cards-service-types": "static-1.3712",
  "content-media-composition-data-lib": "static-1.12896",
  "content-media-compositions": "static-2.16903",
  "media-bridge-lib": "static-1.19235",
  "react-reducer-toolkit": "static-1.16093",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4683",
  "storybook-react": "static-1.36",
  "audio-components": "static-1.6180",
  "FileManagerImages": "static-1.37295",
  "video-components": "static-1.13866",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.57",
  "urlinator": "static-1.4708",
  "video-embed": "static-1.36356",
  "ui-addon-video-player": "static-1.8882",
  "ui-coaching-tips": "static-1.29061",
  "ContentData": "static-1.68967",
  "layout-data-lib": "static-1.10086",
  "social-insights-client-types": "static-1.22548",
  "outpost": "static-1.4344",
  "growth-onboarding-feedback-components": "static-1.6755",
  "advanced-menus-core": "static-1.15421",
  "advanced-menus-lib": "static-1.12316",
  "ExportDialog": "static-6.10555",
  "ui-memberships-settings-lib": "static-1.34536",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15420",
  "simple-menus-lib": "static-1.16937"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34978",
  "atom": "/atom/static-1.5252",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2675",
  "client-types": "/client-types/static-1.489",
  "cssUtils": "/cssUtils/static-1.843",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40461",
  "customer-data-objects": "/customer-data-objects/static-1.7856",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8272",
  "documents-lib": "/documents-lib/static-1.34983",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.352",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86319",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4898",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2331",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.107",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5770",
  "hs-test-utils": "/hs-test-utils/static-1.8199",
  "hub-http": "/hub-http/static-1.6396",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11958",
  "HubStyleTokens": "/HubStyleTokens/static-2.11651",
  "I18n": "/I18n/static-7.1645",
  "icons": "/icons/static-2.665",
  "jasmine-immutable": "/jasmine-immutable/static-1.3199",
  "jasmine-runner": "/jasmine-runner/static-1.6632",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7328",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5570",
  "quartz": "/quartz/static-1.7263",
  "react": "/react/static-7.189",
  "react-dlb": "/react-dlb/static-1.83",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16878",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-utils": "/react-utils/static-2.5468",
  "react-virtualized": "/react-virtualized/static-2.102",
  "reference-resolvers": "/reference-resolvers/static-1.8352",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8273",
  "reporting-data": "/reporting-data/static-1.68252",
  "reporting-reports": "/reporting-reports/static-1.67930",
  "reporting-snowflake": "/reporting-snowflake/static-1.56870",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10185",
  "reporting-visualizations": "/reporting-visualizations/static-1.60328",
  "reselect": "/reselect/static-3.8",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9126",
  "sanitize": "/sanitize/static-1.4654",
  "sanitize-text": "/sanitize-text/static-1.8322",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1921",
  "signup-constants": "/signup-constants/static-1.19320",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8235",
  "StyleGuideUI": "/StyleGuideUI/static-3.491",
  "superstore": "/superstore/static-1.4934",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4934",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11166",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11258",
  "ui-images": "/ui-images/static-2.1206",
  "UIComponents": "/UIComponents/static-3.8597",
  "usage-tracker": "/usage-tracker/static-1.7527",
  "usage-tracker-container": "/usage-tracker-container/static-1.7517",
  "usage-tracker-core": "/usage-tracker-core/static-1.7377",
  "viral-links-lib": "/viral-links-lib/static-1.7248",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9835",
  "foundations-components": "/foundations-components/static-1.8278",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1041",
  "quartz-core": "/quartz-core/static-1.6482",
  "quick-fetch": "/quick-fetch/static-1.4044",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4834",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11325",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18224",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3527",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3540",
  "quartz-webpack": "/quartz-webpack/static-1.3487",
  "foundations-assets": "/foundations-assets/static-1.5051",
  "foundations-theming": "/foundations-theming/static-1.4615",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10401",
  "hubspotter-http": "/hubspotter-http/static-1.4778",
  "sassPrefix": "/sassPrefix/static-1.160",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7425",
  "crm-message-bus": "/crm-message-bus/static-1.43491",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22896",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13206",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13353",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10001",
  "events-data-lib": "/events-data-lib/static-1.414",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4133",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6976",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7071",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3715",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3973",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1160",
  "onboarding-tours": "/onboarding-tours/static-1.16937",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14194",
  "stylex": "/stylex/static-1.37",
  "trellis-assets": "/trellis-assets/static-1.2284",
  "trellis-components": "/trellis-components/static-1.2303",
  "trellis-theming": "/trellis-theming/static-1.1125",
  "ui-addon-teams": "/ui-addon-teams/static-1.21771",
  "quartz-auth": "/quartz-auth/static-1.938",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9257",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5213",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9408",
  "ContentUtils": "/ContentUtils/static-1.68892",
  "customer-data-properties": "/customer-data-properties/static-1.52183",
  "forms-ai-lib": "/forms-ai-lib/static-1.4592",
  "forms-utils-lib": "/forms-utils-lib/static-1.12907",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5761",
  "react-dnd-compat": "/react-dnd-compat/static-1.4791",
  "react-tinymce": "/react-tinymce/static-1.55720",
  "tinymce-config": "/tinymce-config/static-2.54846",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10526",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3600",
  "HeadJS": "/HeadJS/static-2.777",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3310",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "hs-locale-management": "/hs-locale-management/static-1.208",
  "ui-fonts": "/ui-fonts/static-1.913",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4500",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.928",
  "web-vitals": "/web-vitals/static-1.9",
  "batch-promise": "/batch-promise/static-1.1721",
  "external-options-client-types": "/external-options-client-types/static-1.4253",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.938",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8104",
  "graphql": "/graphql/static-1.85",
  "persist-promise": "/persist-promise/static-1.3878",
  "reporting-client-types": "/reporting-client-types/static-1.2604",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.89",
  "growth-payments-core": "/growth-payments-core/static-1.25915",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5053",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1303",
  "quartz-routing": "/quartz-routing/static-1.693",
  "hs-story-utils": "/hs-story-utils/static-1.9602",
  "react-flip-move": "/react-flip-move/static-1.74",
  "nested-table": "/nested-table/static-1.413",
  "timezone-utils": "/timezone-utils/static-2.5420",
  "seat-types-lib": "/seat-types-lib/static-1.408",
  "react-create-root-preference": "/react-create-root-preference/static-1.45",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4547",
  "floating-ui": "/floating-ui/static-1.60",
  "react-aria": "/react-aria/static-1.69",
  "tanstack-table": "/tanstack-table/static-1.58",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.852",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.551",
  "module-federation": "/module-federation/static-1.29",
  "quartz-test": "/quartz-test/static-1.938",
  "quartz-tracking": "/quartz-tracking/static-1.642",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.244",
  "chirp-fetch": "/chirp-fetch/static-1.2064",
  "merchandise-lib": "/merchandise-lib/static-1.267",
  "purchase-motions-components": "/purchase-motions-components/static-1.6175",
  "salesImages": "/salesImages/static-1.529",
  "ts-schema": "/ts-schema/static-1.4207",
  "bender-build-tools": "/bender-build-tools/static-1.3308",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3098",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1367",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hs-resources": "/hs-resources/static-1.355",
  "pulse": "/pulse/static-1.791",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3924",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4265",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.190",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3819",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18940",
  "growth-data-modal": "/growth-data-modal/static-1.5719",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3239",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2442",
  "navigation-components": "/navigation-components/static-1.18506",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5151",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1003",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10438",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7819",
  "ui-universal-auth": "/ui-universal-auth/static-1.9186",
  "user-context": "/user-context/static-1.5287",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "tanstack-virtual": "/tanstack-virtual/static-1.33",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10399",
  "magpie-lib": "/magpie-lib/static-1.5670",
  "navigation-messaging": "/navigation-messaging/static-1.7833",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.22211",
  "copilot-toolkit": "/copilot-toolkit/static-1.11592",
  "cms-field-types": "/cms-field-types/static-1.4991",
  "content-icons-ui": "/content-icons-ui/static-1.2279",
  "integrations-lib": "/integrations-lib/static-1.16724",
  "calling-global-api": "/calling-global-api/static-1.65116",
  "calling-internal-common": "/calling-internal-common/static-1.31489",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66498",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58792",
  "commerce-products-lib": "/commerce-products-lib/static-1.10227",
  "crm-links": "/crm-links/static-1.6491",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9728",
  "file-manager-components": "/file-manager-components/static-1.24144",
  "formula-editor": "/formula-editor/static-1.14570",
  "google-libphonenumber": "/google-libphonenumber/static-1.41",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4344",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.809",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49326",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4094",
  "property-value-citations": "/property-value-citations/static-1.2797",
  "smart-property-lib": "/smart-property-lib/static-1.8059",
  "tiered-pricing": "/tiered-pricing/static-1.1722",
  "topics-actions-lib": "/topics-actions-lib/static-1.326",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9252",
  "zustand": "/zustand/static-1.74",
  "final-form": "/final-form/static-1.73",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.20138",
  "tinymce-themes": "/tinymce-themes/static-1.56816",
  "data-token-picker": "/data-token-picker/static-1.16720",
  "hub-http-contrib": "/hub-http-contrib/static-1.3219",
  "interframe": "/interframe/static-3.4932",
  "tinymce-data": "/tinymce-data/static-1.40931",
  "tinymce-plugins": "/tinymce-plugins/static-1.57960",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5389",
  "onboarding-scopes": "/onboarding-scopes/static-1.6635",
  "ui-addon-opt": "/ui-addon-opt/static-4.8537",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4828",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.512",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.349",
  "purchase-motions-api": "/purchase-motions-api/static-1.6178",
  "event-emitter": "/event-emitter/static-1.1127",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.294",
  "fast-json-patch": "/fast-json-patch/static-1.66",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2266",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2470",
  "user-context-client": "/user-context-client/static-1.4727",
  "idb-keyval": "/idb-keyval/static-1.47",
  "magpie-types": "/magpie-types/static-1.5130",
  "nest": "/nest/static-1.412",
  "reactive-lib": "/reactive-lib/static-1.901",
  "simple-logging-lib": "/simple-logging-lib/static-1.3226",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.982",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18058",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1357",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14139",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5784",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7957",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10541",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.700",
  "calling-error-reporting": "/calling-error-reporting/static-1.31496",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11213",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6717",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1635",
  "customer-data-tracking": "/customer-data-tracking/static-1.7062",
  "commerce-permissions": "/commerce-permissions/static-1.952",
  "products-iframe-lib": "/products-iframe-lib/static-1.8362",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10783",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9783",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4325",
  "video-components-external": "/video-components-external/static-1.11864",
  "video-data-lib": "/video-data-lib/static-1.35522",
  "bark-lib": "/bark-lib/static-1.16663",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.98",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6064",
  "react-codemirror": "/react-codemirror/static-1.10810",
  "data-agent-kit": "/data-agent-kit/static-1.474",
  "feedback-loader": "/feedback-loader/static-1.29627",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10484",
  "fsm": "/fsm/static-1.3906",
  "policy-lib": "/policy-lib/static-1.6961",
  "react-colorpicker": "/react-colorpicker/static-2.10384",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10547",
  "FileManagerLib": "/FileManagerLib/static-1.39784",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9178",
  "FileManagerCore": "/FileManagerCore/static-1.39643",
  "content-assistance-lib": "/content-assistance-lib/static-1.8025",
  "layout-dnd-components": "/layout-dnd-components/static-1.12786",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11761",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10060",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15936",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15296",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7783",
  "breeze-engine-core": "/breeze-engine-core/static-1.635",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.82",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3189",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.203",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.695",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.768",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.878",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.219",
  "slack-ui-library": "/slack-ui-library/static-1.10574",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36412",
  "sales-views-client-types": "/sales-views-client-types/static-1.4435",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3712",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12896",
  "content-media-compositions": "/content-media-compositions/static-2.16903",
  "media-bridge-lib": "/media-bridge-lib/static-1.19235",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16093",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4683",
  "storybook-react": "/storybook-react/static-1.36",
  "audio-components": "/audio-components/static-1.6180",
  "FileManagerImages": "/FileManagerImages/static-1.37295",
  "video-components": "/video-components/static-1.13866",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.57",
  "urlinator": "/urlinator/static-1.4708",
  "video-embed": "/video-embed/static-1.36356",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8882",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29061",
  "ContentData": "/ContentData/static-1.68967",
  "layout-data-lib": "/layout-data-lib/static-1.10086",
  "social-insights-client-types": "/social-insights-client-types/static-1.22548",
  "outpost": "/outpost/static-1.4344",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6755",
  "advanced-menus-core": "/advanced-menus-core/static-1.15421",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12316",
  "ExportDialog": "/ExportDialog/static-6.10555",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34536",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15420",
  "simple-menus-lib": "/simple-menus-lib/static-1.16937"
}
};
